import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const SiteContainer = styled.div`
    padding: 44px 0 0 0;
`;

export const SubContainer = styled.div`
    padding: 44px 121px 0;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: ${ScreenSize.laptop}px){
        flex-direction: row;
        padding: 44px 0 0;
    };
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        flex-direction: column;
        padding: 32px 0 0;
    };
`;

export const Title = styled.h1`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-weight: 600;
    color: ${colors.black};
    font-size: 44px;
    margin: 0;
    padding: 0 0 0 36px;
    @media screen and (max-width: 1919px) {
        font-size: 32px;
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 20px;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        padding: 33px 0 0 65px;
    }
`;
